module.exports = __webpack_public_path__ + "img/bg_honor_desk_3.779da206.png";